import axiosInstance from '../axiosInterceptor/axiosInstance'

const updateSeasonTeamPlayer = async (orgId, seasonTeamPlayerId, playerData) => {
  const url = `v1/orgs/${orgId}/season-team-players/${seasonTeamPlayerId}`
  const response = await axiosInstance.patch(url, playerData)
  return response?.data
}

export default updateSeasonTeamPlayer
